"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import { useRouter } from "next/navigation";
import { useContext } from "react";
export default function DistributionPlanToolConnected() {
  const $ = _c(7);
  const {
    requestAuth
  } = useContext(AuthContext);
  const router = useRouter();
  let t0;
  if ($[0] !== requestAuth || $[1] !== router) {
    t0 = async () => {
      const {
        success
      } = await requestAuth();
      if (!success) {
        return;
      }
      router.push("/emma/plans");
    };
    $[0] = requestAuth;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const trySignIn = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h1 className="tw-text-white">Sign in</h1>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-mb-6 tw-max-w-2xl"><ul className="tw-text-justify tw-space-y-1 tw-mb-0 tw-mt-2 tw-text-base tw-leading-[1.6] tw-font-normal tw-text-iron-300"><li>Sign in with an address that's a part of your consolidated account to proceed, so that we can verify your TDH to grant you access.</li><li>No special delegation is required.</li><li>Review the message carefully.</li><li>Please don't connect your vault.</li><li>No gas is needed to sign in, and there is currently no cost or fee to use the tool.</li></ul></div>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== trySignIn) {
    t3 = <div className="tw-flex tw-flex-col">{t1}{t2}<div className="tw-flex"><PrimaryButton onClicked={trySignIn} disabled={false} loading={false}>Sign In with Web3</PrimaryButton></div></div>;
    $[5] = trySignIn;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}